import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializePerformance } from "firebase/performance";



const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "testingstuff-47ffc.firebaseapp.com",
  projectId: "testingstuff-47ffc",
  storageBucket: "testingstuff-47ffc.appspot.com",
  messagingSenderId: "439788352619",
  appId: "1:439788352619:web:a9fc656273b1de8a5b2d2e"
};

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_KEY2,
//   authDomain: "appsecoex.firebaseapp.com",
//   projectId: "appsecoex",
//   storageBucket: "appsecoex.appspot.com",
//   messagingSenderId: "438187341701",
//   appId: "1:438187341701:web:dd1929c5f49bde22acf6ec",
//   measurementId: "G-BYNVQFYYB2"
// };

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, 'europe-west1');

// experimentalForceLongPolling: el autodetect de transporte (default en el SDK)
// abría primero un WebChannel de streaming que se quedaba colgado ~2s en cada
// carga en frío antes de caer a long-polling con una sesión nueva — ese hueco
// muerto retrasaba la primera query de TODA la app (medido con Playwright:
// sesión A xmlhttp abandonada → sesión B long-polling 2s después). Forzando
// long-polling desde el inicio se salta ese intento fallido y la primera query
// sale justo tras el token de auth (~0,6s en vez de ~2,6s).
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalForceLongPolling: true,
});
export const auth = getAuth();
export const storage = getStorage(app);

// Firebase Performance: deshabilitado por defecto. La instrumentación automática
// envía POSTs a firebaselogging-pa.googleapis.com que estaban tardando 1,5-2,5 s
// y degradaban la navegación. Las trazas custom (usePerfTrace) son no-ops si perf
// es null. Para reactivar telemetría, exportar REACT_APP_ENABLE_PERF=true.
export const perf = process.env.REACT_APP_ENABLE_PERF === 'true'
  ? initializePerformance(app, { dataCollectionEnabled: true, instrumentationEnabled: true })
  : null;

export { functions };

// Caché en memoria: evita transacciones IndexedDB de ~47s que bloqueaban getDocs()
// Para un dashboard admin siempre online, la persistencia offline no aporta valor